import React from "react";
// Components
import { Button, Tooltip } from "components";
// Resources
import { ExportIcon } from "constants/SvgIcons";

type AnimalStatus = "selected" | "on-farm" | "archived";

export interface ExportAnimalsButtonProps {
  numAnimals: number;
  onClick: () => void;
  isLoading: boolean;
  // TODO: Remove this logic for a simplified tooltip label once BRD-2351 is done.
  // https://breedr.atlassian.net/browse/BRD-2351
  animalStatus?: AnimalStatus;
  isServerList?: boolean;
}

const serverPaginatedTooltipTitle: Record<AnimalStatus, string> = {
  archived: "Export all archived animals to CSV",
  selected: "Export selected animals to CSV",
  "on-farm": "Export all on-farm animals to CSV",
};

export const ExportAnimalsButton: React.FC<ExportAnimalsButtonProps> = ({
  numAnimals,
  onClick,
  isLoading,
  animalStatus,
  isServerList,
}) => {
  if (!numAnimals || isLoading) return <Button disabled icon={{ image: ExportIcon, position: "left" }} />;

  const tooltipTitle =
    numAnimals > 1 ? `Export these ${numAnimals} animals to csv` : `Export this ${numAnimals} animal to csv`;

  // We have to wrap button in div as material ui throws console error
  // regarding wrapping a tooltip around a (potentially) disabled button
  return (
    <Tooltip
      title={isServerList && animalStatus ? serverPaginatedTooltipTitle[animalStatus] : tooltipTitle}
      placement="top"
    >
      <div>
        <Button
          icon={{
            image: ExportIcon,
            position: "left",
          }}
          onClick={onClick}
        />
      </div>
    </Tooltip>
  );
};
